/**
 * MapTagGroup.jsx
 *
 * @Author: zhangce
 * @Date: 18/8/7 下午5:35
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MapTag from './MapTag';

/**
 * MapTagGroup
 * */
class MapTagGroup extends React.PureComponent {
  static propTypes = {
    /**
     * 类前缀
     * */
    prefixCls: PropTypes.string,
    /**
     * 类名
     * */
    className: PropTypes.string,
    /**
     * 默认值
     * */
    defaultValue: PropTypes.array,
    /**
     * 标签样式类型
     * */
    maptagType: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'error', 'info']),
    /**
     * 添加新标签按钮的文案说明
     * */
    addText: PropTypes.string,
    /**
     * 值改变时回调函数
     * */
    onChange: PropTypes.func,
    /**
     * 是否显示添加按钮
     * */
    hasAddableMapTag: PropTypes.bool,
    /**
     * 创建新标签的键值
     * */
    enterKey: PropTypes.array,
    /**
     * 自动聚焦input框
     * */
    autoTriggerAdd: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
  };

  static defaultProps = {
    prefixCls: 'ne-maptag-group',
    defaultValue: [],
    maptagType: 'error',
    addText: '+ new MapTag',
    hasAddableMapTag: true,
    autoTriggerAdd: false,
    size: 'medium',
  };

  static getDerivedStateFromProps(props, state) {
    if (props.defaultValue !== state.prevDefaultValue) {
      return {
        maptags: props.defaultValue,
        prevDefaultValue: props.defaultValue,
      };
    }
    return null;
  }

  constructor(props, context) {
    super(props, context);
    const { defaultValue } = props;
    this.state = {
      maptags: defaultValue,
      prevDefaultValue: defaultValue,
    };
    const { onChange } = this.props;
    onChange && onChange(defaultValue);
  }

  handleClose = maptagRemove => {
    const { onChange } = this.props;
    const { maptags } = this.state;
    const newMapTags = maptags.filter(maptag => maptag.value !== maptagRemove);
    this.setState({ maptags: newMapTags });
    onChange && onChange(newMapTags);
  };

  triggerAddMapTagClick = e => {
    const { autoTriggerAdd } = this.props;
    if (autoTriggerAdd && this.addMapTag) {
      this.addMapTag.setInput(e);
    }
  };

  getContainer = el => {
    this.maptagContainer = el;
  };

  render() {
    const {
      maptagType,
      addText,
      className,
      children,
      hasAddableMapTag,
      enterKey,
      prefixCls,
      size,
      onChange,
      autoTriggerAdd,
      ...other
    } = this.props;
    const { maptags } = this.state;

    return (
      <div
        className={classNames(`${prefixCls}`, className, `${prefixCls}-${size}`)}
        onClick={this.triggerAddMapTagClick}
        {...other}>
        {maptags.map(maptag => (
          <MapTag onDelete={this.handleClose} uuid={maptag.value} key={maptag.value} closable>
            {maptag.label}
          </MapTag>
        ))}
      </div>
    );
  }
}

export default MapTagGroup;



// WEBPACK FOOTER //
// ./src/maptag/MapTagGroup.jsx